export type CacheBustingMethod = 'query-strings' | 'filenames'

export function initCacheBusters() {
	const wasInitialized = typeof useCacheBusting !== 'undefined'
	if (wasInitialized) {
		return
	}

	useCacheBusting = false

	if (window.game.config.build_type === 'dev') {
		return
	}

	if (typeof cacheBusters === 'undefined') {
		console.warn('Cache busting data is missing!')
		return
	}

	if (typeof cacheBustingMethod === 'undefined') {
		console.warn('Cache busting method is not set!')
		return
	}

	useCacheBusting = true

	patchPhaserLoader()
}

/**
 * Patch Phaser loader to add cache busting to all files so instead of loading 'game.png' it will load 'game.MD5_HASH.png'
 */
function patchPhaserLoader() {
	const loaderProto = (Phaser as any).Loader.prototype

	const addToFileListOriginal = loaderProto.addToFileList

	loaderProto.addToFileList = function (
		type: string,
		key: string,
		url: string | string[],
		properties: any,
		...args: any[]
	) {
		url = Array.isArray(url) ? url.map((item) => getCacheBustedUrl(item)) : getCacheBustedUrl(url)

		if (typeof properties === 'object' && properties !== null && 'atlasURL' in properties) {
			let atlasURL = properties.atlasURL
			if (atlasURL && typeof atlasURL === 'string') {
				properties.atlasURL = getCacheBustedUrl(atlasURL)
			}
		}

		return addToFileListOriginal.call(this, type, key, url, properties, ...args)
	}
}

/**
 * Get a cache busted url for the given original url
 * @example getCacheBustedUrl('assets/graphics/page_background.png') -> 'assets/graphics/page_background.MD5_HASH.png'
 * Where MD5_HASH is string like '12e45bs890'
 */
export function getCacheBustedUrl(originalUrl: string): string {
	if (useCacheBusting) {
		let hash = cacheBusters[originalUrl]
		if (hash) {
			return transformUrl(originalUrl, hash)
		}

		return originalUrl
	}

	return originalUrl
}

function transformUrl(originalUrl: string, hash: string): string {
	if (cacheBustingMethod === 'filenames') {
		return transformFilename(originalUrl, hash)
	} else {
		return `${originalUrl}?v=${hash}`
	}
}

function transformFilename(originalUrl: string, hash: string) {
	let dotIndex = originalUrl.indexOf('.')
	let firstPart = originalUrl.slice(0, dotIndex)
	let lastPart = originalUrl.slice(dotIndex)

	return `${firstPart}.${hash}${lastPart}`
}
